import cx from 'classnames';

import Logo1 from './assets/client-logo1.svg?react';
import Logo2 from './assets/client-logo2.svg?react';
import Logo3 from './assets/client-logo3.svg?react';
import Logo4 from './assets/client-logo4.svg?react';
import Logo5 from './assets/client-logo5.svg?react';
import Logo6 from './assets/client-logo6.svg?react';
import { e, m } from './style.css';

const logos = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6];

const clientLogoClassName = (index: number) => {
    const mod = String(index + 1) as '1' | '2' | '3' | '4' | '5' | '6';

    return cx(e.clientLogo, {
        [m.clientLogo[mod]]: true,
    });
};

export function Clients() {
    return (
        <div className={e.clientLogos}>
            {logos.map((Logo, index) => (
                <Logo
                    key={`logo${index}`}
                    className={clientLogoClassName(index)}
                />
            ))}
        </div>
    );
}
